"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_redux_1 = require("react-redux");
var constants_1 = require("containers/App/constants");
var single_1 = require("utils/selectors/single");
var SidebarGroup_1 = __importDefault(require("../SidebarGroup"));
var AccountantSettings = function (_a) {
    var isLocked = _a.isLocked;
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var menuItems = [profile.isAccountant && constants_1.MENU_ACCOUNTANTS, rechargerCompany && (0, constants_1.GET_MENU_RECHARGES)(rechargerCompany)]
        .filter(end2end_1.notFalsy).flat();
    return ((0, jsx_runtime_1.jsx)(SidebarGroup_1.default, { categoryLabel: "Accountant", menuItems: menuItems, isLocked: isLocked }));
};
exports.default = AccountantSettings;
